import { render } from "./RecibosNomina.vue?vue&type=template&id=6e15c794&scoped=true"
import script from "./RecibosNomina.vue?vue&type=script&lang=js"
export * from "./RecibosNomina.vue?vue&type=script&lang=js"

import "./RecibosNomina.vue?vue&type=style&index=0&id=6e15c794&scoped=true&lang=css"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/gasoil/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e15c794"]])

export default __exports__